import React, { lazy, Suspense } from 'react';
import $ from 'jquery';
import { SocketSync } from "./SocketAPI";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import ErrorBoundary from "./ErrorBoundary";
import PullToRefresh from 'react-simple-pull-to-refresh';
import LazyLoad from 'react-lazyload';
import LoadingPlaceHolder from './RLoadingPlaceHolder';
//import Dashboard from './Dashboard';
import { isNullOrEmpty, HandleOffline, OpenTheUrlinWeb, CreateNewGuid, showConfirmBoxWithCancel,showLockedBox} from "./RUtility";
import MLayout, { CreateTempGuid, getUserTokenMethod } from './MLayout';

const Updates = lazy(() => import('./updates'));
const More = lazy(() => import('./More'));
const Sanjeevan = lazy(() => import('./sanjeevan'));

const N404 = lazy(() => import('./404'));
const Tv = lazy(() => import('./Tv'));
const MiraVerse = lazy(() => import('./MiraVerse'));
const Dashboard = lazy(() => import("./Dashboard"));


//import TinySlider from "tiny-slider-react";
if (process.env.NODE_ENV === 'development') {
    import('./App.css');
    // import('./node_modules/tiny-slider/dist/tiny-slider.css');
}
//const window.historyInstance = createBrowserHistory();


const ChangeCoverPhoto = lazy(() => import('./ChangeCoverPhoto'));
let bodyScroll = document.querySelector("body");
var selfObj;
//var Dashboard = null;// lazy(() => import("./Dashboard"));;

function logDateTime() {
    var today = new Date();
    var date = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate();
    var time = today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds() + ":" + today.getMilliseconds();
    var dateTime = date + ' ' + time;
    console.log(dateTime);
    // return dateTime;
}
var url = "";

//let Dashboard = null


function PushHistory(url) {
    window.historyInstance.push(url);
}
function GetCTFromLocation(isfromLoad) {


    var currentTAB = "home";
    var path = window.location.pathname;
    var currentPage = "home";

    if (path && path.split("/").length > 1 && path.split("/").length < 4) {
        currentPage = path.split("/")[1];
    }

    


    switch (currentPage.toLowerCase()) {

        case "more":
            currentTAB = "more"
            break;
        case "guru":
            currentTAB = "guru"
            break;
        case "tv":
            currentTAB = "tv"
            break;
        case "miraverse":
            currentTAB = "miraverse"
            break;
        case "sanjeevan":
            currentTAB = "sanjeevan"
            break;
        case "d":
            currentTAB = "d"
            break;

        //case "mirracles":
        //    currentTAB = "mirracles"
        //    break;



    }
    if (!isfromLoad && currentTAB == "home") {
        path = path.replace("home", "");
        if (!(path == "/" || path == "//")) {
            return "";
        }
    }

    return currentTAB;
}

let homePageInst = null;
var pagesLoaded = [];
var homeOpenedOnce = false;
class HomeWithNoOverlay extends MLayout {
    constructor(props) {
        //console.log("this.state.CurrentTab");
        //console.log(GetCTFromLocation());
        
        super(props);
       
        homePageInst = this;
        var ct = GetCTFromLocation()

        this.state = { CurrentTab: ct ? ct : "d" }
        // this.setState({ CurrentTab: GetCTFromLocation() });

        if (this.state.CurrentTab && pagesLoaded.indexOf(this.state.CurrentTab.toLowerCase()) == -1) {
            pagesLoaded.push(this.state.CurrentTab.toLowerCase());
        }

        if (!this.props.authToken) {
            //this.props.authToken = getUserTokenMethod();
        }


        if ((this.state.CurrentTab == "/" || this.state.CurrentTab == "home" || this.state.CurrentTab == "") && this.currentPersonDetails) {
            this.setState({ CurrentTab: "d" });
        }
        else if ((this.state.CurrentTab == "d" || this.state.CurrentTab == "home") && !this.props.authToken) {
            this.setState({ CurrentTab: "home" });
            // window.historyInstance.push("/epass");
            //https://www.pinnacleblooms.org

            //window.location.href = "/epass?navigateTo=" + encodeURIComponent(location.href);
        }

        var lang = localStorage.getItem("Language");
        this.UpdateLang(lang);
        var isPreviousTabContainer = true;
        window.historyInstance.listen((location, action) => {
            //console.log(action);
            //console.log(location);
            //console.log("window.historyInstance.referrer");
            //console.log(window.historyInstance);
            //console.log(window.historyInstance.referrer);
            if (window && window.location.href && window.location.href.indexOf("opencompodate") > -1) {
                try {
                    document.getElementById('compo-date-picker-id').focus();
                } catch (e) {

                }
               
            }
          if (window && window.location.href && window.location.href.indexOf("openleaverequestdate") > -1) {
                try {
                    document.getElementById('leaverequest-date-picker-id').focus();
                } catch (e) {

                }
               
            }

            $('html, body').removeClass('popUpBackround');
            var currentTab = GetCTFromLocation();
            if (!currentTab && (!this.state || !this.state.CurrentTab)) {
                currentTab = "d";
            }

            if (currentTab) {
                //console.log("excellent");
                if ((currentTab == "d" || currentTab == "home") && (!this.props.currentPersonDetails && window.CPD)) {
                    currentTab = "d"
                    this.props.currentPersonDetails = window.CPD;
                }

                if (isPreviousTabContainer) {
                    let top = sessionStorage.getItem(currentTab.toLowerCase());

                    if (top == null) {
                        top = 0;
                        ///window.scrollTo(0,0);
                    } else {
                        //  window.scrollTo(0, parseInt(top));
                    }

                    setTimeout(function () { bodyScroll.scrollTop = top; }, 100);
                    // sessionStorage.setItem(currentTab.toLowerCase(),"");
                }
                //sidebar.scrollTop = parseInt(top, 0);


                //sessionStorage.setItem(this.state.CurrentTab.toLowerCase(), $('body').scrollTop);
                this.setState({ CurrentTab: currentTab, CPD: this.props.currentPersonDetails });
                isPreviousTabContainer = true;
            }
            else {
                isPreviousTabContainer = false;
            }
        });
        if (this.props.currentPersonDetails) {
            // Dashboard = lazy(() => import("./Dashboard"));
        }
        //console.log("CurrentTab");
        //console.log(this.state.CurrentTab);
        if (process.env.NODE_ENV === 'development') {
            import('./App.css');
        }
      

    }

    componentDidMount() {

        if(homeOpenedOnce)
        {
            return;
        }
        if (this.currentPersonDetails) {
            // Dashboard = lazy(() => import("./Dashboard"));
        }

        console.log("HOMEJS");
        if (this.props.currentPersonDetails && !this.props.currentPersonDetails.Name) {
            var currentURL = window.location.href;
            if (!currentURL.includes('/signup')) {
              //  window.historyInstance.push("/signup");
            }
        }
        // var leaderRoles = ["receptionist", "manager", "owner", "ccc", "harvestadmin", "facilityowner"];
        var role = localStorage.getItem("UserRoles");

        // var nav = role && leaderRoles.some(item => role.toLowerCase().includes(item));
        if (role) {
            this.setState({ CurrentRoles: role });
        }

        if (this.props.currentPersonDetails)
            this.setState({ currentPersonDetails: this.props.currentPersonDetails });
        // this.ManageUserAggregates(this.state.currentRole);
        homeOpenedOnce = true;
    }
    NavigatetoRespectCreation(type) {
        try {
            if (!HandleOffline(function () { homePageInst.NavigatetoRespectCreation(type); }, false, function () { homePageInst.CloseCreationsOverlay(); })) {
                return;
            }
            
            if (isNullOrEmpty(type)) {
                return;
            }
            window.historyInstance.push(type);
        } catch (e) {

        }
    }
    OpenCreationsOverlay() {
        this.setState({ showCreationsOverlay: true });
        $('html, body').addClass('popUpBackround');
    }

    CloseCreationsOverlay() {
        var $this = this;
        setTimeout(function () {
            $this.setState({ showCreationsOverlay: false });
        }, 500);

        $('html, body').removeClass('popUpBackround');
        $('.submit-wrapper').removeClass('is-saving');
    }


    EnableChangeCoverPhoto = function (user,role) {
        console.log("this");
        if (user && role && role.toLowerCase() == "receptionist") {
            role = "NCC";
        }
        $("body").addClass("popUpBackround");
        homePageInst.setState({ isCoverPhotoOverlayEnabled: true, CurrentRole: role  });
    }
    DisbaleChangeCoverPhoto = function () {
        $("body").removeClass("popUpBackround");
        homePageInst.setState({ isCoverPhotoOverlayEnabled: false });
    }

    ChangedCOverPhoto = function () {
        console.log("this.state.ChangedCOverPhoto");
        var bool = homePageInst.state.coverPhotoChanged ? homePageInst.state.coverPhotoChanged : false;

        homePageInst.setState({ coverPhotoChanged: !bool });
    }

    OnDemandSync() {

        return new Promise(res => {
           
        
        
        homePageInst.setState({ IsSync: true });

        SocketSync(0, function (result, error) {
            try {
                homePageInst.setState({ IsSync: false });
                if (error) {
                    showLockedBox(error.ErrorMsg, false);
                }
            } catch (e) {
                console.log("Error in OnDemandSync :" + e);
            }
            res([]);
            return false;
        }, true, "ForceRefresh");
        });

    }


    VerifyRoyaltyPayment = function () {
        if (this.props.userData && this.props.userData.FData) {
            var data = $.grep(this.props.userData.FData, function (e) { return e.AT == "ROYALTY" })[0];
            var $this = this;
            if (data) {
                //showConfirmBoxWithCancel("", "Please do clear royalty amount", "Cleared Already", false, function (data) {
                //    $this.OnDemandSync();
                //});
            }
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {        
        if (prevProps != this.props) {           

            if (this.props.userData && this.props.userData.Data) {
                var alertsData = $.grep(this.props.userData.Data, function (e) { return e.AT && e.AT == "ALERT" && (!e.RS || (e.RS && e.RS.toLowerCase() != "delete")) });
                var lDate = localStorage.getItem("ALSD");
                if (lDate) {
                    alertsData = $.grep(this.props.userData.Data, function (e) { return new Date(e.CDT) > lDate });
                }
                var aCount = alertsData && alertsData.length > 0 ? alertsData.length : 0;
                this.setState({ AlertCount: aCount });
                if (aCount > 0) {
                    $(".menu-block").addClass('active');
                } else {
                    $(".menu-block").removeClass('active');
                }
            }

            if (this.props.userData && this.props.userData.FData) {
                //console.log("ENTERED");

                this.VerifyRoyaltyPayment();

            }

            try {

                if (this.props.userData && this.props.userData.FInfo) {
                    var filters = ["BLOGPOST", "IMAGEGALLERY", "SURVEY", "FILE", "AUDIO", "VIDEO"];

                    var data = this.props.userData.FInfo;
                    console.log("Home Guru data");
                    console.log(data);

                   
                    
                    var result = $.grep(data, function (e) {
                        return ((filters && filters.length > 0) ? (e.AT && filters.indexOf(e.AT) > -1) : true)
                    });

                    var lDate = localStorage.getItem("GURULSD");
                    var lData;
                    if (lDate) {
                        lData = $.grep(result, function (e) { return new Date(e.CDT) > lDate });
                    }
                    else {
                        lData = result;
                    }
                    var aCount = lData && lData.length > 0 ? lData.length : 0;
                    if (aCount > 0) {
                        $("guru-bubble").show();
                    }
                    this.setState({ GuruCount: aCount });
                    

                }
            } catch (e) {

            }
          
        }
    }

    componentWillUnmount() {
        window.removeEventListener('online', this.handleConnectionChange);
        window.removeEventListener('offline', this.handleConnectionChange);

    }

    onItemClick(e) {
        //  e.preventDefault();
        // do something hereov
        //alert(e);

        sessionStorage.setItem(this.state.CurrentTab.toLowerCase(), bodyScroll.scrollTop);
        if (pagesLoaded.indexOf(this.state.CurrentTab.toLowerCase()) == -1) {
            pagesLoaded.push(this.state.CurrentTab.toLowerCase());
        }
        $('body').removeAttr('class');
        window.Is404Page = false;
        $('body').addClass(e);
        // this.setState({ CurrentTab: e });
        if (e && this.state.CurrentTab.toLowerCase() == e.toLowerCase()) {
            $('.tab-item.' + e.toLowerCase()).animate({ scrollTop: 0 }, 0);
        }
        if(e && e == "d" && this.state.CurrentTab.toLowerCase() != "d"){
            //this.setState({ AllowDashboardRendering: true });
            sessionStorage.setItem("AllowDashboardRendering", "true");  
        }
        else{
            sessionStorage.removeItem("AllowDashboardRendering");
        }
        PushHistory("/" + e);
    }


    

    openUrl() {
        try {
            window.open("https://api.whatsapp.com/send?phone=919100181181&text=" + encodeURIComponent("I need support with therapy for my kid/") + "%0a%0a", '_top')
            //OpenTheUrlinWeb("https://api.whatsapp.com/send?phone=919100181181&text=" + encodeURIComponent("I need support with therapy for my kid/") + "%0a%0a")
        } catch (err) {
            console.log("Error in openUrl : " + err);
        }
    }

    render() {
        var leaderRoles = ["receptionist", "manager", "owner", "ccc", "harvestadmin", "facilityowner"];
        //console.log("==Home Dashboard==");
        //console.log(Dashboard);
        var isDataUpdated = sessionStorage.getItem("IsProfileDataUpdated");
        //try {
        //    if (isDataUpdated && isDataUpdated == "true") {
        //        var uData = localStorage.getItem("UserData");
        //        if (uData) {
        //            var person = JSON.parse(uData);
        //            person.ImageURL = this.props.currentPersonDetails.ImageURL + "?v=" + CreateTempGuid();
        //            dataStore.dispatch(StoreUser(person));
        //        }
        //    }
        //} catch (e) {

        //}

        var miraverse = window.location.href.indexOf("/miraverse") > -1;


        if (((this.props.currentPersonDetails || this.props.authToken) && !Dashboard) || (isDataUpdated && isDataUpdated == "true")) {

            sessionStorage.setItem("IsSignupCompleted", "");
        }

        return <div>
            {
            this.state.isCoverPhotoOverlayEnabled ?
                    <div className="change-coverphotooverlay">
                        <div className="change-bg" onClick={this.DisbaleChangeCoverPhoto.bind(this)}>
                        </div>
                        <svg onClick={this.DisbaleChangeCoverPhoto.bind(this)} xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="24px" height="24px" viewBox="0 0 24 24" strokeWidth={1}><g strokeWidth={1} transform="translate(0.5, 0.5)"><line data-color="color-2" fill="none" stroke="#444444" strokeWidth={1} strokeLinecap="square" strokeMiterlimit={10} x1={16} y1={8} x2={8} y2={16} strokeLinejoin="miter" /> <line data-color="color-2" fill="none" stroke="#444444" strokeWidth={1} strokeLinecap="square" strokeMiterlimit={10} x1={16} y1={16} x2={8} y2={8} strokeLinejoin="miter" /> <circle fill="none" stroke="#444444" strokeWidth={1} strokeLinecap="square" strokeMiterlimit={10} cx={12} cy={12} r={11} strokeLinejoin="miter" /></g></svg>

                        <div className="change-cc">


                         
                            
                            <Suspense fallback={<LoadingPlaceHolder Height="800px" />}>
                                <ChangeCoverPhoto CurrentRole={this.state.CurrentRole} ChangedCOverPhoto={this.ChangedCOverPhoto} />
                    </Suspense>
                </div>
            </div>
                        :
            ""
            }


            <div className="nihwn-header">
                <div className="provider-top-container">

                    <div className="overlay-top-bar">

                        <div className="provider-top-container">

                            <div className="searchbox_wrapper" >

                                <div className="searchheader-location top-header">
                                  
                                    <div><div className="add left-menu m-main-menu" style={{
                                        position: "relative",
                                        top: "3px"
}}>
                                        <Link to={"/more"}>
                                            <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="32px" height="32px" viewBox="0 0 32 32" strokeWidth={2}><g strokeWidth={2} transform="translate(0, 0)"><g className="js-nc-int-icon nc-int-menu-to-arrow-bottom-3 js-nc-int-icon-loaded" strokeWidth={2}><line fill="none" stroke="#024463" strokeLinecap="square" strokeMiterlimit={10} strokeWidth={2} x1={30} x2={2} y1={8} y2={8} strokeLinejoin="miter" /><line fill="none" stroke="#024463" strokeLinecap="square" strokeMiterlimit={10} strokeWidth={2} x1={2} x2={30} y1={16} y2={16} data-color="color-2" strokeLinejoin="miter" /><line fill="none" stroke="#024463" strokeLinecap="square" strokeMiterlimit={10} strokeWidth={2} x1={30} x2={2} y1={24} y2={24} strokeLinejoin="miter" /></g><style data-cap="butt" strokeWidth={2} strokeLinecap="butt" strokeLinejoin="miter" dangerouslySetInnerHTML={{ __html: ".nc-int-menu-to-arrow-bottom-3{--transition-duration:0.3s;transform-origin:50% 50%;transition:transform var(--transition-duration) cubic-bezier(.86,0,.07,1)}.nc-int-menu-to-arrow-bottom-3 *{stroke-dasharray:28px;stroke-dashoffset:56px;transition:transform var(--transition-duration) cubic-bezier(.86,0,.07,1),stroke-dashoffset var(--transition-duration) cubic-bezier(.86,0,.07,1)}.nc-int-menu-to-arrow-bottom-3 :nth-child(1){transform-origin:2px 8px}.nc-int-menu-to-arrow-bottom-3 :nth-child(3){transform-origin:2px 24px}.nc-int-menu-to-arrow-bottom-3.nc-int-icon-state-b{transform:rotate(-90deg)}.nc-int-menu-to-arrow-bottom-3.nc-int-icon-state-b :nth-child(1),.nc-int-menu-to-arrow-bottom-3.nc-int-icon-state-b :nth-child(3){stroke-dashoffset:44px}.nc-int-menu-to-arrow-bottom-3.nc-int-icon-state-b :nth-child(1){transform:translateY(8px) translateX(7px) rotate(-45deg)}.nc-int-menu-to-arrow-bottom-3.nc-int-icon-state-b :nth-child(2){stroke-dashoffset:28px}.nc-int-menu-to-arrow-bottom-3.nc-int-icon-state-b :nth-child(3){transform:translateY(-8px) translateX(7px) rotate(45deg)}" }} /></g></svg>

                                        </Link>
                                    </div></div>

                                    <div className="logo-block"> <Link to={"/pinnacleip"}>
                                        <img src="/images/pinnacle-logo-1.jpg?v=23" style={{ height:"100%",float:"left"}}/>
                                    </Link>
                                        </div>
                                      
                                    {
                                        (this.state.CurrentRoles && leaderRoles.some(item => this.state.CurrentRoles.toLowerCase().includes(item))) ?
                                            <div >
                                                <div onClick={this.OpenCreationsOverlay.bind(this)} style={{ marginRight: "2px" }} className="add m-main-menu" >
                                                    <svg style={{ padding:"4px" }} xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="32px" height="32px" viewBox="0 0 32 32" strokeWidth="2"><g strokeWidth="2" transform="translate(0, 0)"><line fill="none" stroke="#444444" strokeWidth="2" strokeLinecap="square" strokeMiterlimit="10" x1="16" y1="2" x2="16" y2="30" strokeLinejoin="miter"></line> <line fill="none" stroke="#444444" strokeWidth="2" strokeLinecap="square" strokeMiterlimit="10" x1="30" y1="16" x2="2" y2="16" strokeLinejoin="miter"></line></g></svg>
                                                </div>
                                            </div> : ""
                                    }
                                    
                                    <div className="menu-block" style={{ position: "relative", display: "none" }}>
                                        <Link to="/notifications" style={{ marginLeft: "2px", marginRight: "10px" }} className="add m-main-menu" >
                                            <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="48px" height="48px" viewBox="0 0 48 48" strokeWidth="2" style={{width: "28px",height: "30px"}}><g strokeWidth="2" transform="translate(0, 0)"><path d="M43,37s-5-7-5-13V16A14,14,0,0,0,24,2h0A14,14,0,0,0,10,16v8c0,6-5,13-5,13Z" fill="none" stroke="#444444" strokeLinecap="square" strokeMiterlimit="10" strokeWidth="2" strokeLinejoin="miter"></path><path data-cap="butt" data-color="color-2" d="M29,41a5,5,0,0,1-10,0" fill="none" stroke="#444444" strokeMiterlimit="10" strokeWidth="2" strokeLinecap="butt" strokeLinejoin="miter"></path></g></svg>
                                        </Link>
                                        <span>{this.state.AlertCount}</span>
                                    </div>

                                    {
                                        <div>
                                            <div onClick={this.OnDemandSync.bind(this)} style={{ marginRight: "2px", marginLeft: "2px" }} className="add m-main-menu" >

                                                <svg className={this.state.IsSync ? "syncrotate" : ""} xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="32px" height="32px" viewBox="0 0 32 32" strokeWidth={1} style={{ width: '25px', height: '25px', marginRight: '6px', marginTop: '-2px', color: '#444' }}><g strokeWidth={1} transform="translate(0, 0)"><path data-cap="butt" d="M29.382,9.217A15,15,0,0,0,1,16" fill="none" stroke="#444" strokeMiterlimit={10} strokeWidth={2} strokeLinecap="butt" strokeLinejoin="miter" /><polyline points="28.383 1.22 29.383 9.22 21.383 8.22" fill="none" stroke="#444" strokeLinecap="square" strokeMiterlimit={10} strokeWidth={2} strokeLinejoin="miter" /><path data-cap="butt" data-color="color-2" d="M2.618,22.783A15,15,0,0,0,31,16" fill="none" stroke="#444" strokeMiterlimit={10} strokeWidth={2} strokeLinecap="butt" strokeLinejoin="miter" /><polyline data-color="color-2" points="3.617 30.78 2.617 22.78 10.617 23.78" fill="none" stroke="#444" strokeLinecap="square" strokeMiterlimit={10} strokeWidth={2} strokeLinejoin="miter" /></g></svg>
                                            </div>
                                        </div>
                                    }
                                    <div>
                                        <span style={{ display: "inline-block" }} onClick={ this.openUrl.bind(this)}>
                                            <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="48px" height="48px" viewBox="0 0 48 48"><g transform="translate(0, 0)"><path fill="#3AC34C" d="M0.10739,48l3.37542-12.32542c-2.08204-3.60688-3.17763-7.69894-3.17592-11.89098 C0.31215,10.66928,10.98554,0,24.09976,0c6.36475,0.00253,12.33865,2.47971,16.83067,6.97547 c4.49214,4.49575,6.96465,10.47174,6.96218,16.82712c-0.00531,13.11432-10.67966,23.785-23.79253,23.785h-0.00006h-0.00974 c-3.98213-0.00164-7.89481-1.00024-11.36995-2.89505L0.10739,48z"></path> <path fillRule="evenodd" clipRule="evenodd" fill="#FFFFFF" d="M18.15336,13.84087 c-0.48253-1.1589-0.97266-1.0021-1.33759-1.02027c-0.34636-0.01724-0.74309-0.02088-1.13941-0.02088 s-1.04036,0.14873-1.5853,0.74366c-0.54492,0.59496-2.08067,2.03281-2.08067,4.958c0,2.92519,2.13022,5.7512,2.42748,6.14787 c0.29723,0.39667,4.19204,6.39961,10.15569,8.97392c1.41836,0.6123,2.52578,0.9779,3.38909,1.25194 c1.42423,0.45222,2.72022,0.38844,3.74456,0.23544c1.14216-0.17059,3.51729-1.43777,4.01272-2.82601 c0.49537-1.38824,0.49537-2.57817,0.34674-2.82608c-0.14856-0.24784-0.54491-0.3966-1.13937-0.69412 c-0.59452-0.29745-3.51734-1.73529-4.06233-1.93359c-0.54491-0.19831-0.9412-0.29746-1.33755,0.29751 c-0.39628,0.59491-1.5356,1.9336-1.88241,2.3302c-0.34674,0.39667-0.69355,0.44627-1.28801,0.14876 c-0.59453-0.29745-2.51008-0.92506-4.7808-2.94978c-1.76725-1.57578-2.96047-3.52215-3.30725-4.11712 c-0.34677-0.59496-0.03689-0.91665,0.26073-1.2129c0.26739-0.26626,0.59446-0.69412,0.89172-1.04118 c0.29723-0.34706,0.39632-0.59497,0.59446-0.99157c0.19818-0.39667,0.09909-0.74372-0.04955-1.04121 C19.83772,17.956,18.64879,15.03077,18.15336,13.84087z"></path></g></svg>
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
            {this.state.showCreationsOverlay ?
                <div id="payment-overlay" onClick={this.CloseCreationsOverlay.bind(this)} className="working-inprogress-overlay-withanimations active" >
                    <div>
                        <div className="overlay-container payment-section" style={{ width: "320px", top:"25%" ,left: "7%" }}>
                            {/*<div className="close-section">*/}
                            {/*    <div style={{ float: "left", paddingTop: "9px", display: "flex" }} onClick={this.CloseCreationsOverlay.bind(this)}>*/}
                            {/*        <span style={{ color: "#3C79FB", fontSize: "14px" }}>*/}
                            {/*            Back*/}
                            {/*        </span>*/}
                            {/*    </div>*/}
                            {/*</div>*/}
                            <div className="open-creations">
                                <div>
                                    
                                    
                                   
                                    <div className="open-ct">
                                        <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="64px" height="64px" viewBox="0 0 64 64" strokeWidth="1"><g strokeWidth="1" transform="translate(0.5, 0.5)"><line data-color="color-2" fill="none" stroke="#444444" strokeWidth="1" strokeLinecap="square" strokeMiterlimit="10" x1="38" y1="22" x2="34" y2="22" strokeLinejoin="miter"></line> <line data-color="color-2" fill="none" stroke="#444444" strokeWidth="1" strokeLinecap="square" strokeMiterlimit="10" x1="26" y1="22" x2="22" y2="22" strokeLinejoin="miter"></line> <line data-color="color-2" fill="none" stroke="#444444" strokeWidth="1" strokeLinecap="square" strokeMiterlimit="10" x1="14" y1="22" x2="10" y2="22" strokeLinejoin="miter"></line> <line data-color="color-2" fill="none" stroke="#444444" strokeWidth="1" strokeLinecap="square" strokeMiterlimit="10" x1="38" y1="52" x2="34" y2="52" strokeLinejoin="miter"></line> <line data-color="color-2" fill="none" stroke="#444444" strokeWidth="1" strokeLinecap="square" strokeMiterlimit="10" x1="50" y1="22" x2="46" y2="22" strokeLinejoin="miter"></line> <line data-color="color-2" fill="none" stroke="#444444" strokeWidth="1" strokeLinecap="square" strokeMiterlimit="10" x1="50" y1="52" x2="46" y2="52" strokeLinejoin="miter"></line> <line data-color="color-2" fill="none" stroke="#444444" strokeWidth="1" strokeLinecap="square" strokeMiterlimit="10" x1="26" y1="52" x2="22" y2="52" strokeLinejoin="miter"></line> <line data-color="color-2" fill="none" stroke="#444444" strokeWidth="1" strokeLinecap="square" strokeMiterlimit="10" x1="14" y1="52" x2="10" y2="52" strokeLinejoin="miter"></line> <circle data-stroke="none" fill="#444444" cx="48" cy="37" r="2" strokeLinejoin="miter" strokeLinecap="square"></circle> <path fill="none" stroke="#444444" strokeWidth="1" strokeLinecap="square" strokeMiterlimit="10" d="M7,15c-2.761,0-5-2.239-5-5 v0c0-2.761,2.239-5,5-5h40v4" strokeLinejoin="miter"></path> <path fill="none" stroke="#444444" strokeWidth="1" strokeLinecap="square" strokeMiterlimit="10" d="M58,31V15H7 c-2.761,0-5-2.239-5-5v41c0,4.418,3.582,8,8,8h48V43" strokeLinejoin="miter"></path> <path data-color="color-2" fill="none" stroke="#444444" strokeWidth="1" strokeLinecap="square" strokeMiterlimit="10" d="M62,43H48 c-3.314,0-6-2.686-6-6v0c0-3.314,2.686-6,6-6h14V43z" strokeLinejoin="miter"></path></g></svg>
                                        <div className="open-link" onClick={this.NavigatetoRespectCreation.bind(this, "/createinvoice")} >Invoice</div>                                       
                                        <div className="open-ct inside-open" style={{paddingLeft:"57px"}}>
                                            <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="64px" height="64px" viewBox="0 0 64 64" strokeWidth="1"><g strokeWidth="1" transform="translate(0.5, 0.5)"><circle data-stroke="none" fill="#444444" cx="48" cy="40" r="2" strokeLinejoin="miter" strokeLinecap="square"></circle> <path fill="none" stroke="#444444" strokeWidth="1" strokeLinecap="square" strokeMiterlimit="10" d="M7,18c-2.761,0-5-2.239-5-5 v0c0-2.761,2.239-5,5-5h4" strokeLinejoin="miter"></path> <path fill="none" stroke="#444444" strokeWidth="1" strokeLinecap="square" strokeMiterlimit="10" d="M58,34V18H7 c-2.761,0-5-2.239-5-5v41c0,4.418,3.582,8,8,8h48V46" strokeLinejoin="miter"></path> <path data-color="color-2" fill="none" stroke="#444444" strokeWidth="1" strokeLinecap="square" strokeMiterlimit="10" d="M62,46H48 c-3.314,0-6-2.686-6-6v0c0-3.314,2.686-6,6-6h14V46z" strokeLinejoin="miter"></path> <polyline data-color="color-2" fill="none" stroke="#444444" strokeWidth="1" strokeLinecap="square" strokeMiterlimit="10" points=" 11,13 11,2 51,2 51,13 11,13 " strokeLinejoin="miter"></polyline></g></svg>                                            
                                            <div className="open-link" onClick={this.NavigatetoRespectCreation.bind(this, "/createexpense")} >Expense</div>
                                        </div>
                                    </div>
                                    <div className="open-ct">
                                        <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="48px" height="48px" viewBox="0 0 48 48" strokeWidth="1"><g strokeWidth="1" transform="translate(0.5, 0.5)"><polyline fill="none" stroke="#444444" strokeWidth="1" strokeLinecap="square" strokeMiterlimit="10" points="22,30 2,30 2,2 42,2 42,15 " strokeLinejoin="miter"></polyline> <ellipse data-color="color-2" fill="none" stroke="#444444" strokeWidth="1" strokeLinecap="square" strokeMiterlimit="10" cx="37" cy="24" rx="9" ry="4" strokeLinejoin="miter"></ellipse> <path data-cap="butt" data-color="color-2" fill="none" stroke="#444444" strokeWidth="1" strokeMiterlimit="10" d="M28,24v6c0,2.209,4.029,4,9,4 s9-1.791,9-4v-6" strokeLinejoin="miter" strokeLinecap="butt"></path> <path data-cap="butt" data-color="color-2" fill="none" stroke="#444444" strokeWidth="1" strokeMiterlimit="10" d="M28,30v6c0,2.209,4.029,4,9,4 s9-1.791,9-4v-6" strokeLinejoin="miter" strokeLinecap="butt"></path> <path data-cap="butt" data-color="color-2" fill="none" stroke="#444444" strokeWidth="1" strokeMiterlimit="10" d="M28,36v6c0,2.209,4.029,4,9,4 s9-1.791,9-4v-6" strokeLinejoin="miter" strokeLinecap="butt"></path> <circle fill="none" stroke="#444444" strokeWidth="1" strokeLinecap="square" strokeMiterlimit="10" cx="22" cy="16" r="4" strokeLinejoin="miter"></circle></g></svg>                                        
                                        <div className="open-link" onClick={this.NavigatetoRespectCreation.bind(this, "/createlead")} >Lead</div>
                                        <div className="open-ct inside-open" style={{ paddingLeft: "72px" }}>
                                            <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="64px" height="64px" viewBox="0 0 64 64" strokeWidth="2"><g strokeWidth="2" transform="translate(0, 0)"><rect x="5" y="5" width="54" height="54" rx="5" ry="5" fill="none" stroke="#444444" strokeLinecap="square" strokeMiterlimit="10" strokeWidth="2" strokeLinejoin="miter"></rect> <line data-cap="butt" data-color="color-2" x1="32" y1="30" x2="37" y2="20" fill="none" stroke="#444444" strokeMiterlimit="10" strokeWidth="2" strokeLinecap="butt" strokeLinejoin="miter"></line> <path data-color="color-2" d="M32,12A18,18,0,0,0,14,30H50A18,18,0,0,0,32,12Z" fill="none" stroke="#444444" strokeLinecap="square" strokeMiterlimit="10" strokeWidth="2" strokeLinejoin="miter"></path></g></svg>                                            
                                            <div className="open-link" onClick={this.NavigatetoRespectCreation.bind(this, "/serviceland?type=create")} >Services</div>
                                        </div>
                                    </div>
                                    <div className="open-ct">
                                        <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="64px" height="64px" viewBox="0 0 64 64" strokeWidth="1"><g strokeWidth="1" transform="translate(0.5, 0.5)"><path data-cap="butt" data-color="color-2" fill="none" stroke="#444444" strokeWidth="1" strokeMiterlimit="10" d="M21.427,27.439 C20.464,25.41,18.395,24,16,24H8c-3.314,0-6,2.686-6,6v8l4,2l1,14h11" strokeLinejoin="miter" strokeLinecap="butt"></path> <circle data-color="color-2" fill="none" stroke="#444444" strokeWidth="1" strokeLinecap="square" strokeMiterlimit="10" cx="12" cy="12" r="6" strokeLinejoin="miter"></circle> <path data-cap="butt" data-color="color-2" fill="none" stroke="#444444" strokeWidth="1" strokeMiterlimit="10" d="M42.573,27.439 C43.536,25.41,45.605,24,48,24h8c3.314,0,6,2.686,6,6v8l-4,2l-1,14H46" strokeLinejoin="miter" strokeLinecap="butt"></path> <circle data-color="color-2" fill="none" stroke="#444444" strokeWidth="1" strokeLinecap="square" strokeMiterlimit="10" cx="52" cy="12" r="6" strokeLinejoin="miter"></circle> <path fill="none" stroke="#444444" strokeWidth="1" strokeLinecap="square" strokeMiterlimit="10" d="M38,62H26l-1-16l-5-1V32 c0-4.418,3.582-8,8-8h8c4.418,0,8,3.582,8,8v13l-5,1L38,62z" strokeLinejoin="miter"></path> <circle fill="none" stroke="#444444" strokeWidth="1" strokeLinecap="square" strokeMiterlimit="10" cx="32" cy="10" r="8" strokeLinejoin="miter"></circle></g></svg>                                        
                                        <div className="open-link" onClick={this.NavigatetoRespectCreation.bind(this, "/createstaff?type=create")} >Staff</div>
                                        <div className="open-ct inside-open">
                                            <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="48px" height="48px" viewBox="0 0 48 48" strokeWidth="1"><g strokeWidth="1" transform="translate(0.5, 0.5)"><path data-color="color-2" fill="none" stroke="#444444" strokeWidth="1" strokeLinecap="square" strokeMiterlimit="10" d="M24,11 c0-4.971,4.029-9,9-9s9,4.029,9,9s-4.029,11-9,11S24,15.971,24,11z" strokeLinejoin="miter"></path> <path data-cap="butt" data-color="color-2" fill="none" stroke="#444444" strokeWidth="1" strokeMiterlimit="10" d="M26,27.968 C27.905,27.398,30.227,27,33,27c4.986,0,8.258,1.286,10.273,2.553c1.719,1.082,2.727,3,2.727,5.031V46H33" strokeLinejoin="miter" strokeLinecap="butt"></path> <path fill="none" stroke="#444444" strokeWidth="1" strokeLinecap="square" strokeMiterlimit="10" d="M6,23c0-4.418,3.582-8,8-8 s8,3.582,8,8s-3.582,9-8,9S6,27.418,6,23z" strokeLinejoin="miter"></path> <path fill="none" stroke="#444444" strokeWidth="1" strokeLinecap="square" strokeMiterlimit="10" d="M26,42.494 c0-1.628-0.977-3.1-2.488-3.705C21.432,37.957,18.141,37,14,37s-7.432,0.957-9.512,1.789C2.977,39.394,2,40.867,2,42.494V46h24 V42.494z" strokeLinejoin="miter"></path></g></svg>                                            
                                            <div className="open-link" onClick={this.NavigatetoRespectCreation.bind(this, "/createparent?type=create")} >Parent</div>
                                        </div>
                                    </div>
                                    
                                    <div className="open-ct">
                                        <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="48px" height="48px" viewBox="0 0 48 48" strokeWidth="1"><g strokeWidth="1" transform="translate(0.5, 0.5)"><path d="M24,46A22,22,0,1,1,46,24" fill="none" stroke="#444444" strokeLinecap="square" strokeMiterlimit="10" strokeWidth="1" strokeLinejoin="miter"></path> <line x1="32" y1="45" x2="46" y2="45" fill="none" stroke="#444444" strokeLinecap="square" strokeMiterlimit="10" strokeWidth="1" data-color="color-2" strokeLinejoin="miter"></line> <line x1="32" y1="38" x2="46" y2="38" fill="none" stroke="#444444" strokeLinecap="square" strokeMiterlimit="10" strokeWidth="1" data-color="color-2" strokeLinejoin="miter"></line> <line x1="32" y1="31" x2="46" y2="31" fill="none" stroke="#444444" strokeLinecap="square" strokeMiterlimit="10" strokeWidth="1" data-color="color-2" strokeLinejoin="miter"></line> <polygon points="18 16 32 24 18 32 18 16" fill="none" stroke="#444444" strokeLinecap="square" strokeMiterlimit="10" strokeWidth="1" data-color="color-2" strokeLinejoin="miter"></polygon></g></svg>                                        
                                        <div className="open-link" onClick={this.NavigatetoRespectCreation.bind(this, "/trumpet")} >Guru</div>
                                        <div className="open-ct inside-open" style={{ paddingLeft: "48px" }}>
                                            <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="48px" height="48px" viewBox="0 0 48 48" strokeWidth="1"><g strokeWidth="1" transform="translate(0.5, 0.5)"><path fill="none" stroke="#444444" strokeWidth="1" strokeLinecap="square" strokeMiterlimit="10" d="M2,42h2 c2.209,0,4-1.791,4-4v-2l-4.451-2.318c-1.462-0.761-1.427-2.865,0.06-3.577L8,28v-4l4.573-1.143 c1.508-0.377,2.028-2.255,0.929-3.354L8,14V4" data-color="color-2" strokeLinejoin="miter"></path> <path fill="none" stroke="#444444" strokeWidth="1" strokeLinecap="square" strokeMiterlimit="10" d="M16,32l6-8V12 c0-2.209,1.791-4,4-4h16c2.209,0,4,1.791,4,4v16c0,2.209-1.791,4-4,4H28H16z" strokeLinejoin="miter"></path> <line fill="none" stroke="#444444" strokeWidth="1" strokeLinecap="square" strokeMiterlimit="10" x1="30" y1="16" x2="38" y2="16" strokeLinejoin="miter"></line> <line fill="none" stroke="#444444" strokeWidth="1" strokeLinecap="square" strokeMiterlimit="10" x1="30" y1="24" x2="38" y2="24" strokeLinejoin="miter"></line></g></svg>                                            
                                            <div className="open-link" onClick={this.NavigatetoRespectCreation.bind(this, "/touchbase")} >Touch Base</div>
                                        </div>
                                    </div>
                                    <div className="open-ct">
                                        <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="64px" height="64px" viewBox="0 0 64 64" strokeWidth="2"><g strokeWidth="2" transform="translate(0, 0)"><rect x="5" y="5" width="54" height="54" rx="5" ry="5" fill="none" stroke="#444444" strokeLinecap="square" strokeMiterlimit="10" strokeWidth="2" strokeLinejoin="miter"></rect> <line data-cap="butt" data-color="color-2" x1="32" y1="30" x2="37" y2="20" fill="none" stroke="#444444" strokeMiterlimit="10" strokeWidth="2" strokeLinecap="butt" strokeLinejoin="miter"></line> <path data-color="color-2" d="M32,12A18,18,0,0,0,14,30H50A18,18,0,0,0,32,12Z" fill="none" stroke="#444444" strokeLinecap="square" strokeMiterlimit="10" strokeWidth="2" strokeLinejoin="miter"></path></g></svg>                                        
                                        <div className="open-link" onClick={this.NavigatetoRespectCreation.bind(this, "/bookassessment")} >Book Assessment</div>
                                    </div>


                                    <div className="open-ct inside-open" style={{ paddingLeft: "68px" }}>
                                        <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="64px" height="64px" viewBox="0 0 64 64" strokeWidth="1"><g strokeWidth="1" transform="translate(0.5, 0.5)"><polyline fill="none" stroke="#444444" strokeWidth="1" strokeLinecap="square" strokeMiterlimit="10" points="22,40 2,40 2,2 36,2 36,18 " strokeLinejoin="miter"></polyline> <rect x="28" y="24" fill="none" stroke="#444444" strokeWidth="1" strokeLinecap="square" strokeMiterlimit="10" width="34" height="38" strokeLinejoin="miter"></rect> <path data-cap="butt" data-color="color-2" fill="none" stroke="#444444" strokeWidth="1" strokeMiterlimit="10" d="M44,10h8c4.418,0,8,3.582,8,8v0" strokeLinejoin="miter" strokeLinecap="butt"></path> <polyline data-color="color-2" fill="none" stroke="#444444" strokeWidth="1" strokeLinecap="square" strokeMiterlimit="10" points=" 50,4 44,10 50,16 " strokeLinejoin="miter"></polyline> <path data-cap="butt" data-color="color-2" fill="none" stroke="#444444" strokeWidth="1" strokeMiterlimit="10" d="M20,54h-8c-4.418,0-8-3.582-8-8 v0" strokeLinejoin="miter" strokeLinecap="butt"></path> <polyline data-color="color-2" fill="none" stroke="#444444" strokeWidth="1" strokeLinecap="square" strokeMiterlimit="10" points=" 14,60 20,54 14,48 " strokeLinejoin="miter"></polyline></g></svg>
                                        <div className="open-link" onClick={this.NavigatetoRespectCreation.bind(this, "/compensation")} >Compo</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div> : null
            }

            {
                miraverse  ?  "" :
            <Link to={"/mirracles"} className="mirracles-tab-more" >
                        <svg style={{
                            height: '50px', width: '50px'
                        }} className="line" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="64px" height="64px" viewBox="0 0 64 64" strokeWidth={2}><g strokeWidth={2} transform="translate(0, 0)"><path data-cap="butt" fill="none" stroke="#000" strokeWidth={2} strokeMiterlimit={10} d="M12,22v20c0,4.971,8.954,9,20,9 c11.046,0,20-4.029,20-9V22" strokeLinecap="butt" strokeLinejoin="miter" /> <polyline data-cap="butt" data-color="color-2" fill="none" stroke="#000" strokeWidth={2} strokeMiterlimit={10} points="44,54 49,61 39,61 44,54 44,26 " strokeLinecap="butt" strokeLinejoin="miter" /> <polygon fill="none" stroke="#000" strokeWidth={2} strokeLinecap="square" strokeMiterlimit={10} points="32,32 4,18 32,4 60,18 " strokeLinejoin="miter" /></g></svg>

               </Link>
            }

            {/* <PullToRefresh refreshingContent={<LoadingPlaceHolder imagewidth="30px" mt="5px" LoadingText="Fetching Latest Data..." fmt="2px" fs="15px" Height="100px" />} onRefresh={this.OnDemandSync}> */}
            <ErrorBoundary>
                <>
            {this.props.authToken && Dashboard ? <div id="main-dashboard-scroll-container" data-changed={this.state.coverPhotoChanged? "true":"false"} className={"tab-item d " + (this.state.CurrentTab && (this.state.CurrentTab.toLowerCase() == "d" || this.state.CurrentTab.toLowerCase() == "home") ? "active" : "")}>
                {this.state.CurrentTab && (this.state.CurrentTab.toLowerCase() == "d" || this.state.CurrentTab.toLowerCase() == "home") ?
                     <Suspense fallback={<LoadingPlaceHolder LoadingText="Preparing Pinnacle Wisdom for you..." IsPageLoaderReqired={false} Height="800px" />}>


                                <Dashboard  Enabled={this.state.coverPhotoChanged ? this.state.coverPhotoChanged : false} EnableChangeCoverPhoto={this.EnableChangeCoverPhoto} />


                     </Suspense>

                    : null}
            </div> :
                <div className={"tab-item home " + (this.state.CurrentTab && this.state.CurrentTab.toLowerCase() == "home" ? "active" : "")}>
                    {(this.state.CurrentTab && this.state.CurrentTab.toLowerCase() == "home") || pagesLoaded.indexOf("home") > -1 ? <Home /> : null}
                </div>
            }


          
                    <div id="tab-item-miraverse" className={"tab-item miraverse " + (this.state.CurrentTab && this.state.CurrentTab.toLowerCase() == "miraverse" ? "active" : "")}>

                        {(this.state.CurrentTab && this.state.CurrentTab.toLowerCase() == "miraverse") || pagesLoaded.indexOf("miraverse") > -1 ? <Suspense fallback={<LoadingPlaceHolder IsPageLoaderReqired={true} Height="800px" />}><MiraVerse TabName={this.state.CurrentTab} /></Suspense> : null}

            </div>

            <div className={"tab-item mirracles " + (this.state.CurrentTab && this.state.CurrentTab.toLowerCase() == "mirracles" ? "active" : "")}>

                {(this.state.CurrentTab && this.state.CurrentTab.toLowerCase() == "tv") || pagesLoaded.indexOf("tv") > -1 ? <Suspense fallback={<LoadingPlaceHolder IsPageLoaderReqired={true} Height="800px" />}><Tv /></Suspense> : null}

            </div>
            <div className={"tab-item " + (this.state.CurrentTab && this.state.CurrentTab.toLowerCase() == "guru" ? "active" : "")}>
                {(this.state.CurrentTab && this.state.CurrentTab.toLowerCase() == "guru") || pagesLoaded.indexOf("guru") > -1 ? <Suspense fallback={<LoadingPlaceHolder IsPageLoaderReqired={true} Height="800px" />}>
                     <Updates /></Suspense> : null}
            </div>
            <div className={"tab-item sanjeevan " + (this.state.CurrentTab && this.state.CurrentTab.toLowerCase() == "sanjeevan" ? "active" : "")}>
                {(this.state.CurrentTab && this.state.CurrentTab.toLowerCase() == "sanjeevan") || pagesLoaded.indexOf("sanjeevan") > -1 ? <Suspense fallback={<LoadingPlaceHolder IsPageLoaderReqired={true} Height="800px" />}><Sanjeevan /></Suspense> : null}
            </div>

            <div className={"tab-item more " + (this.state.CurrentTab && this.state.CurrentTab.toLowerCase() == "more" ? "active" : "")}>
                {(this.state.CurrentTab && this.state.CurrentTab && this.state.CurrentTab.toLowerCase() == "more") || pagesLoaded.indexOf("more") > -1 ? <Suspense fallback={<LoadingPlaceHolder IsPageLoaderReqired={true} Height="800px" />}><More currentPersonDetails={this.currentPersonDetails} /></Suspense> : null}
            </div>
            
              
                    </>

                </ErrorBoundary>
            <div className="nihwn-footer bottom-controls boss">
                <div className={"tabButton " + (this.state.CurrentTab && this.state.CurrentTab.toLowerCase() == "guru" ? "active" : "")}>
                    <a to="/guru" onClick={this.onItemClick.bind(this, "guru")}>

                        <svg className="line" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="32px" height="32px" viewBox="0 0 32 32" strokeWidth="1"><g strokeWidth="1" transform="translate(0.5, 0.5)"><path data-color="color-2" d="M9,28.657A7.786,7.786,0,0,1,2,24.6c-2.5-4.3.6-15.8.6-15.8S4.042,9.178,6,9.832" fill="none" stroke="#444444" strokeLinecap="square" strokeMiterlimit="10" strokeWidth="1" strokeLinejoin="miter"></path> <path data-color="color-2" d="M26,9.832C27.958,9.178,29.4,8.8,29.4,8.8s3.1,11.5.6,15.8a7.786,7.786,0,0,1-7,4.057" fill="none" stroke="#444444" strokeLinecap="square" strokeMiterlimit="10" strokeWidth="1" strokeLinejoin="miter"></path> <path d="M7,17.9C7,12.3,16,3,16,3s9,9.3,9,14.9A8.909,8.909,0,0,1,16,27,8.909,8.909,0,0,1,7,17.9Z" fill="none" stroke="#444444" strokeLinecap="square" strokeMiterlimit="10" strokeWidth="1" strokeLinejoin="miter"></path></g></svg>
                        <svg className="solid" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="32px" height="32px" viewBox="0 0 32 32"><g transform="translate(0, 0)"><path data-color="color-2" d="M30.61,6.488l-.242-.959-.96.242a56.846,56.846,0,0,0-5.7,1.888C25.947,10.861,28,14.678,28,17.9a11.8,11.8,0,0,1-8.181,11.457A9.875,9.875,0,0,0,30.6,24.65C33.674,19.5,30.748,7.037,30.61,6.488Z" fill="#444444"></path> <path data-color="color-2" d="M4,17.9c0-3.222,2.053-7.039,4.288-10.242a56.992,56.992,0,0,0-5.7-1.887l-.96-.242-.242.959C1.252,7.037-1.674,19.5,1.4,24.65a9.875,9.875,0,0,0,10.78,4.707A11.8,11.8,0,0,1,4,17.9Z" fill="#444444"></path> <path d="M16.7,2.3,16,1.6l-.7.7C14.9,2.7,6,11.9,6,17.9a10,10,0,1,0,20,0C26,11.9,17.1,2.7,16.7,2.3Z" fill="#444444"></path></g></svg>

                        {
                            this.state.GuruCount && this.state.GuruCount > 0 ?
                                <span id="guru-bubble" style={{ background: '#f52e57', borderRadius: '50%', color: '#fff', fontSize: '10px', padding: '1px', position: 'absolute', right: '5px', top: '-5px', width: '18px', height: '18px', paddingTop: '9px' }}>{this.state.GuruCount}</span>
                                :
                                ""
                        }
                        

                        <span className="tabName tag-name english-lang activelang">Guru</span>
                        <span className="tag-name telugu-lang">
                            Guru
                    </span>
                        <span className="tag-name hindi-lang">
                            Guru
                    </span>

                    </a>
                </div>
                <div className={"tabButton " + (this.state.CurrentTab && this.state.CurrentTab.toLowerCase() == "sanjeevan" ? "active" : "")}>
                    <a to="/sanjeevan" onClick={this.onItemClick.bind(this, "sanjeevan")} >
                        <svg className="line" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="32px" height="32px" viewBox="0 0 32 32" strokeWidth="1"><g strokeWidth="1" transform="translate(0.5, 0.5)"><path fill="none" stroke="#444444" strokeWidth="1" strokeLinecap="square" strokeMiterlimit="10" d="M16,5.1 C16,2.8,14.2,1,11.9,1c-1.8,0-3.3,1.2-3.8,2.8c-0.1,0-0.2,0-0.2,0C4.1,3.7,1,6.8,1,10.5c0,1.8,0.7,3.5,1.9,4.7C1.8,16,1,17.3,1,18.7 c0,1.4,0.7,2.6,1.7,3.3c-0.2,0.7-0.4,1.4-0.4,2.1c0,3.8,3.1,6.8,6.8,6.8s6.8-3.1,6.8-6.8V14" strokeLinejoin="miter"></path> <path fill="none" stroke="#444444" strokeWidth="1" strokeLinecap="square" strokeMiterlimit="10" d="M16,5.1 C16,2.8,17.8,1,20.1,1c1.8,0,3.3,1.2,3.8,2.8c0.1,0,0.2,0,0.2,0c3.8,0,6.8,3.1,6.8,6.8c0,1.8-0.7,3.5-1.9,4.7c1.1,0.7,1.9,2,1.9,3.5 c0,1.4-0.7,2.6-1.7,3.3c0.2,0.7,0.4,1.4,0.4,2.1c0,3.8-3.1,6.8-6.8,6.8S16,27.9,16,24.2" strokeLinejoin="miter"></path> <path fill="none" stroke="#444444" strokeWidth="1" strokeLinecap="square" strokeMiterlimit="10" d="M7.8,17.4 c-1.9,0-3.7-0.8-4.9-2.1" strokeLinejoin="miter"></path> <path fill="none" stroke="#444444" strokeWidth="1" strokeLinecap="square" strokeMiterlimit="10" d="M24.2,17.4 c1.9,0,3.7-0.8,4.9-2.1" strokeLinejoin="miter"></path> <path fill="none" stroke="#444444" strokeWidth="1" strokeLinecap="square" strokeMiterlimit="10" d="M16,5.1C16,7.4,14.3,9,12,9 " strokeLinejoin="miter"></path> <path fill="none" stroke="#444444" strokeWidth="1" strokeLinecap="square" strokeMiterlimit="10" d="M16,5.1C16,7.4,17.7,9,20,9 " strokeLinejoin="miter"></path> <path fill="none" stroke="#444444" strokeWidth="1" strokeLinecap="square" strokeMiterlimit="10" d="M10.5,21.2 c-1.6-0.6-2.7-2.1-2.7-3.9c0-1.2,0.5-2.3,1.4-3" strokeLinejoin="miter"></path> <path fill="none" stroke="#444444" strokeWidth="1" strokeLinecap="square" strokeMiterlimit="10" d="M21.5,21.2 c1.6-0.6,2.7-2.1,2.7-3.9c0-1.2-0.5-2.3-1.4-3" strokeLinejoin="miter"></path></g></svg>
                        <svg className="solid" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="32px" height="32px" viewBox="0 0 32 32"><g transform="translate(0, 0)"><path data-color="color-2" fill="#444444" d="M15,5.1C15,2.8,13.2,1,10.9,1C9.1,1,7.6,2.2,7.1,3.8c-0.1,0-0.2,0-0.2,0C3.1,3.7,0,6.8,0,10.5 c0,1.8,0.7,3.5,1.9,4.7C0.8,16,0,17.3,0,18.7c0,1.4,0.7,2.6,1.7,3.3c-0.2,0.7-0.4,1.4-0.4,2.1c0,3.8,3.1,6.8,6.8,6.8 s6.8-3.1,6.8-6.8V14"></path> <path fill="#444444" d="M17,5.1C17,2.8,18.8,1,21.1,1c1.8,0,3.3,1.2,3.8,2.8c0.1,0,0.2,0,0.2,0c3.8,0,6.8,3.1,6.8,6.8 c0,1.8-0.7,3.5-1.9,4.7c1.1,0.7,1.9,2,1.9,3.5c0,1.4-0.7,2.6-1.7,3.3c0.2,0.7,0.4,1.4,0.4,2.1c0,3.8-3.1,6.8-6.8,6.8 S17,27.9,17,24.2"></path></g></svg>


                        <span className="tabName tag-name english-lang activelang">iSanjeevan</span>
                        <span className="tabName tag-name telugu-lang">
                            iSanjeevan
                    </span>
                        <span className="tabName tag-name hindi-lang">
                            iSanjeevan
                    </span>

                    </a>
                </div>
                <div className={"tabButton " + (this.state.CurrentTab && (this.state.CurrentTab.toLowerCase() == "home" || this.state.CurrentTab.toLowerCase() == "d") ? "active" : "")} >
                    <Link to={this.props.currentPersonDetails ? "/d" : "/home"} onClick={this.onItemClick.bind(this, this.props.currentPersonDetails ? "d" : "home")}>
                        {this.props.currentPersonDetails ?
                            <>
                                {this.props.userData && this.props.userData.CFUser ? <img id="profile-img-fh" src={window.R2Path + '/images/ProfileImages/' + this.props.userData.CFUser.Id + '.jpg?v=' + CreateNewGuid()} onError={(e) => { e.target.onerror = null; e.target.src = window.root + "/images/logos/pinnacle-logo-amblum-100.png" }} style={{ width: "50px", height: "50px", objectFit: "cover", borderRadius: "50%", border: this.state.CurrentTab && this.state.CurrentTab.toLowerCase() == "home" ? "1px solid #000" : "1px solid #eee", marginTop: "-6px" }} /> : <img id="profile-img-fh" src="/images/logos/pinnacle-logo-amblum-100.png" onError={(e) => { e.target.onerror = null; e.target.src = window.root + "/images/logos/pinnacle-logo-amblum-100.png" }} style={{ width: "50px", height: "50px", objectFit: "cover", borderRadius: "50%", border: this.state.CurrentTab && this.state.CurrentTab.toLowerCase() == "home" ? "1px solid #000" : "1px solid #eee", marginTop: "-6px" }} />}
                            </>
                            :
                            <>
                                <img id="profile-img-fh" src="/images/logos/pinnacle-logo-amblum-100.png" onError={(e) => { e.target.onerror = null; e.target.src = window.root + "/images/logos/pinnacle-logo-amblum-100.png" }} style={{ width: "50px", height: "50px", objectFit: "cover", borderRadius: "50%", border: this.state.CurrentTab && this.state.CurrentTab.toLowerCase() == "home" ? "1px solid #000" : "1px solid #eee", marginTop: "-6px" }} />
                                <span className="tabName tag-name english-lang activelang">ME</span>
                                <span className="tabName tag-name telugu-lang">
                                    ఫ్యామిలి
                    </span>
                                <span className="tabName tag-name hindi-lang" >
                                    फैमिली
                    </span>
                            </>
                        }
                    </Link>
                </div>

                {
                  
                    //<div className={"tabButton " + (this.state.CurrentTab && (this.state.CurrentTab.toLowerCase() == "mirracles") ? "active" : "")} >
                    //    <Link to={"/mirracles"} onClick={this.onItemClick.bind(this, this.props.currentPersonDetails ? "d" : "home")}>
                    //        <img src="/images/logos/pinnacle-logo-emblem-200.png" className="mirracles-rotate rotate" />
                    //        <span className="tabName tag-name english-lang activelang">Mirracles</span>
                    //        <span className="tabName tag-name telugu-lang">
                    //            Mirracles
                    //</span>
                    //        <span className="tabName tag-name hindi-lang" >
                    //            Mirracles
                    //</span>
                    //    </Link>
                    //</div>
                }
                
                <div className={"tabButton " + (this.state.CurrentTab && this.state.CurrentTab.toLowerCase() == "miraverse" ? "active" : "")} >
                    <a to="/miraverse" onClick={this.onItemClick.bind(this, "miraverse")}>

                        {
                        //<svg className="line" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="32px" height="32px" viewBox="0 0 32 32" strokeWidth="1"><g strokeWidth="1" transform="translate(0.5, 0.5)"><rect data-color="color-2" x="5" y="12" width="18" height="15" fill="none" stroke="#444444" strokeLinecap="square" strokeMiterlimit="10" strokeWidth="1" strokeLinejoin="miter"></rect><line data-color="color-2" x1="27" y1="12" x2="27" y2="14" fill="none" stroke="#444444" strokeLinecap="square" strokeMiterlimit="10" strokeWidth="1" strokeLinejoin="miter"></line><line data-color="color-2" x1="27" y1="18" x2="27" y2="27" fill="none" stroke="#444444" strokeLinecap="square" strokeMiterlimit="10" strokeWidth="1" strokeLinejoin="miter"></line><line data-cap="butt" x1="12" y1="3" x2="16" y2="8" fill="none" stroke="#444444" strokeMiterlimit="10" strokeWidth="1" strokeLinecap="butt" strokeLinejoin="miter"></line><line data-cap="butt" x1="16" y1="8" x2="22" y2="1" fill="none" stroke="#444444" strokeMiterlimit="10" strokeWidth="1" strokeLinecap="butt" strokeLinejoin="miter"></line><rect x="1" y="8" width="30" height="23" rx="3" fill="none" stroke="#444444" strokeLinecap="square" strokeMiterlimit="10" strokeWidth="1" strokeLinejoin="miter"></rect></g></svg>

                           


                            

                        //<svg className="solid" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="32px" height="32px" viewBox="0 0 32 32"><g transform="translate(0, 0)"><path d="M28,6H18.135l3.633-4.36A1,1,0,1,0,20.232.36L16.041,5.389,13.8,2.4a1,1,0,1,0-1.6,1.2L14,6H4a4,4,0,0,0-4,4V27a4,4,0,0,0,4,4H28a4,4,0,0,0,4-4V10A4,4,0,0,0,28,6ZM23,27H4V10H23Zm5,0H26V17h2Zm0-13H26V10h2Z" fill="#444444"></path></g></svg>

                         //   <img className="rotate" src="https://www.pinnacleblooms.org/images/logos/pinnacle-logo-emblem-200.png" style={{ height: '24px' }} />

                        }
                        <svg style={{
                            height: '35px', width: '35px'}} className="line" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="64px" height="64px" viewBox="0 0 64 64" strokeWidth={2}><g strokeWidth={2} transform="translate(0, 0)"><path data-cap="butt" fill="none" stroke="#444444" strokeWidth={2} strokeMiterlimit={10} d="M12,22v20c0,4.971,8.954,9,20,9 c11.046,0,20-4.029,20-9V22" strokeLinecap="butt" strokeLinejoin="miter" /> <polyline data-cap="butt" data-color="color-2" fill="none" stroke="#444444" strokeWidth={2} strokeMiterlimit={10} points="44,54 49,61 39,61 44,54 44,26 " strokeLinecap="butt" strokeLinejoin="miter" /> <polygon fill="none" stroke="#444444" strokeWidth={2} strokeLinecap="square" strokeMiterlimit={10} points="32,32 4,18 32,4 60,18 " strokeLinejoin="miter" /></g></svg>

                        <svg style={{
                            height: '35px',width: '35px'
                        }} className="solid" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="64px" height="64px" viewBox="0 0 64 64"><g transform="translate(0, 0)"><path fill="#444444" d="M62.423,17.094l-30-14c-0.268-0.125-0.578-0.125-0.846,0l-30,14C1.225,17.258,1,17.611,1,18 s0.225,0.742,0.577,0.906l30,14C31.711,32.969,31.855,33,32,33s0.289-0.031,0.423-0.094L43,27.97V53.68l-4.814,6.739 c-0.217,0.305-0.247,0.705-0.075,1.039C38.282,61.791,38.625,62,39,62h10c0.375,0,0.718-0.209,0.889-0.542 c0.171-0.334,0.142-0.734-0.075-1.039L45,53.68V27.037l17.423-8.131C62.775,18.742,63,18.389,63,18S62.775,17.258,62.423,17.094z" /> <path data-color="color-2" fill="#444444" d="M41,31.111l-7.731,3.608C32.875,34.902,32.436,35,32,35s-0.875-0.098-1.27-0.281L11,25.511 V42c0,5.607,9.224,10,21,10c3.244,0,6.283-0.343,9-0.944V31.111z" /> <path data-color="color-2" fill="#444444" d="M47,28.311v20.748c3.726-1.796,6-4.277,6-7.059V25.51L47,28.311z" /></g></svg>

                        <span className="tabName tag-name english-lang activelang" style={{ position: 'relative', top: '-7px' }}>University</span>
                        <span className="tag-name telugu-lang">
                            University
                    </span>
                        <span className="tag-name hindi-lang">
                            University
                    </span>
                    </a>
                </div>


               

                {
                    <div className={"tabButton " + (this.state.CurrentTab && this.state.CurrentTab.toLowerCase() == "more" ? "active" : "")} >
                        <Link to="/more" onClick={this.onItemClick.bind(this, "more")}>
                            <>
                                <svg className="solid" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="32px" height="32px" viewBox="0 0 32 32"><g transform="translate(0, 0)"><path data-color="color-2" fill="#fe0a00" d="M30,15H2c-0.6,0-1,0.4-1,1s0.4,1,1,1h28c0.6,0,1-0.4,1-1S30.6,15,30,15z"></path> <path fill="#fe0a00" d="M30,6H2C1.4,6,1,6.4,1,7s0.4,1,1,1h28c0.6,0,1-0.4,1-1S30.6,6,30,6z"></path> <path fill="#fe0a00" d="M30,24H2c-0.6,0-1,0.4-1,1s0.4,1,1,1h28c0.6,0,1-0.4,1-1S30.6,24,30,24z"></path></g></svg>
                                <svg className="line" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="32px" height="32px" viewBox="0 0 32 32" strokeWidth="1"><g strokeWidth="1" transform="translate(0.5, 0.5)"><line data-color="color-2" fill="none" stroke="#000000" strokeWidth="1" strokeLinecap="square" strokeMiterlimit="10" x1="2" y1="16" x2="30" y2="16" strokeLinejoin="miter"></line> <line fill="none" stroke="#000000" strokeWidth="1" strokeLinecap="square" strokeMiterlimit="10" x1="2" y1="7" x2="30" y2="7" strokeLinejoin="miter"></line> <line fill="none" stroke="#000000" strokeWidth="1" strokeLinecap="square" strokeMiterlimit="10" x1="2" y1="25" x2="30" y2="25" strokeLinejoin="miter"></line></g></svg>
                                <span className="tabName tag-name english-lang activelang">More</span>
                                <span className="tag-name telugu-lang">
                                    మరిన్ని
                          </span>
                                <span className="tag-name hindi-lang">
                                    मोर
                    </span>
                            </>

                        </Link>
                    </div>
                }
                </div>
            {/* </PullToRefresh> */}
        </div>

    }
}
const mapStateToProps = state => {
    return {
        // To get the list of employee details from store
        userData: state.UD,
        MasterData: state.MD,
        currentPersonDetails: state.U,
        authToken: state.AT
    }
};
export default connect(mapStateToProps, null)(HomeWithNoOverlay)

export class Home extends MLayout {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        var lang = localStorage.getItem("Language");
        this.UpdateLang(lang);
    }

    render() {
        logDateTime();

        return <div className="main-content-div" id="main-content-div">

            <section id="About-nihn">

                <div>
                </div>
            </section>
        </div>
    }
}









